import GroupsContainer from './GroupsContainer';

export default { GroupsContainer };
